import { render, staticRenderFns } from "./NotInterested.vue?vue&type=template&id=1599d565&"
import script from "./NotInterested.vue?vue&type=script&lang=js&"
export * from "./NotInterested.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports